<div class="company-structure-wrapper">
  @if (!structure()) {
    <div class="loading">Ładowanie struktury firmy...</div>
  } @else {
    <div class="page-header">
      <div class="page-header-icon">
        <span nz-icon nzType="apartment" nzTheme="outline"></span>
      </div>
      <div>
        <h2 class="page-header-title">Struktura organizacji</h2>
        <p class="page-header-subtitle">Podstawowe informacje o firmie i jej placówkach</p>
      </div>
    </div>

    <nz-card class="form-card" [nzBordered]="false">
      <div class="card-section-header">
        <span nz-icon nzType="bank" nzTheme="outline" class="section-icon"></span>
        <span>Dane firmy</span>
      </div>

      <div class="company-grid">
        <div class="detail-item">
          <span class="detail-label">Nazwa</span>
          <span class="detail-value">{{ structure()!.name || '-' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Kod</span>
          <span class="detail-value">{{ structure()!.code || '-' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Tenant</span>
          <span class="detail-value">{{ structure()!.tenantName || '-' }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Telefon</span>
          <span class="detail-value">{{ structure()!.phone || '-' }}</span>
        </div>
        <div class="detail-item detail-item-wide">
          <span class="detail-label">Adres</span>
          <span class="detail-value">
            {{
              formatAddress(
                structure()!.city,
                structure()!.street,
                structure()!.houseNo,
                structure()!.flatNo,
                structure()!.zip
              )
            }}
          </span>
        </div>
      </div>
    </nz-card>

    <nz-card class="form-card" [nzBordered]="false">
      <div class="card-section-header">
        <span nz-icon nzType="bank" nzTheme="outline" class="section-icon"></span>
        <span>Placówki</span>
        <nz-tag nzColor="processing" class="units-count">{{ units().length }}</nz-tag>
      </div>

      @if (units().length === 0) {
        <div class="empty-state">Brak placówek w strukturze firmy.</div>
      } @else {
        <div class="units-grid">
          @for (unit of units(); track unit.id) {
            <div class="unit-card">
              <div class="unit-card-title-row">
                <h4 class="unit-card-title">{{ unit.name || '-' }}</h4>
                <div class="unit-card-tags">
                  @if (unit.isReadOnly) {
                    <nz-tag nzColor="warning">Tylko odczyt</nz-tag>
                  }
                  @if (unit.nhfBranchCode && unit.serviceProviderCode) {
                    <nz-tag>{{ getNhfBranchName(unit) }}</nz-tag>
                  }
                </div>
              </div>
              <div class="unit-card-row">
                <span nz-icon nzType="home"></span>
                <span>{{ unitAddress(unit) }}</span>
              </div>
              <div class="unit-card-row">
                <span nz-icon nzType="phone"></span>
                <span>{{ unit.phone || '-' }}</span>
              </div>
              <div class="unit-card-row">
                <span nz-icon nzType="idcard"></span>
                <span>Kod świadczeniodawcy: {{ unit.serviceProviderCode || '-' }}</span>
              </div>
              <div class="unit-card-row unit-card-row-divisions">
                <span nz-icon nzType="apartment"></span>
                <span>Komórki:</span>
                @if (!unit.divisions?.length) {
                  <span class="muted">brak</span>
                } @else {
                  <div class="divisions-list">
                    @for (divisionName of divisionPreview(unit); track divisionName) {
                      <nz-tag>{{ divisionName }}</nz-tag>
                    }
                    @if (divisionRemainingCount(unit) > 0) {
                      <nz-tag>+{{ divisionRemainingCount(unit) }}</nz-tag>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </nz-card>
  }
</div>
